const convertLandToNumber = (land) => {
    if (land === "Österreich") {
        return 1;
    } else if (land === "Deutschland") {
        return 2;
    } else if (land === "Bhutan") {
        return 54;
    } else {
        return land;
    }
}

export function generateInvoicesCSV(selected_invoices, contacts) {
    let csv = ""
    csv += "konto;gkto;belegdat;buchdat;belegnr;text;betrag;mwst;steuer;steucod;gegenbuchkz;verbuchkz;symbol\r\n"
    for (var invoice of selected_invoices) {
        let contact = contacts.get(Number(invoice.customer_id))
        let konto = 4000
        let gkto = contact.steuerberater_kontonummer
        let belegdat = invoice.date.replace(/-/g, '')
        let buchdat = new Date().toISOString().slice(0, 10).replace(/-/g, '')
        let belegnr = invoice.invoice_number.replace(/-/g, '').replace('R', '')
        let text = contact.contact_name
        let betrag = (invoice.sub_total * -1).toString().replace('.', ',')
        let mwst = (invoice.tax_percentage).toString().replace('.', ',')
        let steuer = (invoice.tax_total * -1).toString().replace('.', ',')
        let steucod = 0
        mwst == "20,0" ? steucod = 3 : steucod = 77
        let gegenbuchkz = 'E'
        let verbuchkz = 'A'
        let symbol = 'AR'

        csv += `${konto};${gkto};${belegdat};${buchdat};${belegnr};${text};${betrag};${mwst};${steuer};${steucod};${gegenbuchkz};${verbuchkz};${symbol}\r\n`
    }
    return csv;
}

export function generateContactsCSV(contacts) {
    let csv = ""
    csv += "Kontonummer;Name;Matchcode;Straße;Land;Postleitzahl;Ort;Telefonnummer;E-Mail;UID;\r\n"
    for (var contact of contacts) {
        const kto = contact[1].steuerberater_kontonummer
        const name = contact[1].contact_name.replace(/(\r\n|\n|\r|;)/gm, " ");
        const matchcode = ''
        const str = `${contact[1].billing_address} ${contact[1].billing_street2}`.replace(/(\r\n|\n|\r|;)/gm, " ");
        const land = convertLandToNumber(contact[1].billing_country.replace(/(\r\n|\n|\r|;)/gm, " "));
        const plz = contact[1].billing_zip.replace(/(\r\n|\n|\r|;)/gm, " ");
        const ort = contact[1].billing_city.replace(/(\r\n|\n|\r|;)/gm, " ");
        const tel = contact[1].phone.replace(/(\r\n|\n|\r|;)/gm, " ");
        const email = contact[1].email.replace(/(\r\n|\n|\r|;)/gm, " ");
        const uid = contact[1].uid.replace(/(\r\n|\n|\r|;)/gm, " ");

        csv += `${kto};${name};${matchcode};${str};${land};${plz};${ort};${tel};${email};${uid};\r\n`
    }
    return csv;
}

export function generateCreditNotesCSV(selected_creditnotes, contacts) {
    let csv = ""
    csv += "konto;gkto;belegdat;buchdat;belegnr;text;betrag;mwst;steuer;steucod;gegenbuchkz;verbuchkz;symbol\r\n"
    for (var creditnote of selected_creditnotes) {
        let contact = contacts.get(Number(creditnote.customer_id))
        let konto = contact.steuerberater_kontonummer
        let gkto = 4000
        let belegdat = creditnote.date.replace(/-/g, '')
        let buchdat = new Date().toISOString().slice(0, 10).replace(/-/g, '')
        let belegnr = creditnote.creditnote_number.replace(/-/g, '').replace('GS', '')
        let text = creditnote.reference_number
        let betrag = (creditnote.total * -1).toString().replace('.', ',')
        let mwst = (creditnote.tax_percentage).toString().replace('.', ',')
        let steuer = (creditnote.tax_total * -1).toString().replace('.', ',')
        let steucod = 0
        mwst == "20,0" ? steucod = 1 : steucod = 77
        let gegenbuchkz = 'E'
        let verbuchkz = 'A'
        let symbol = 'GS'

        csv += `${konto};${gkto};${belegdat};${buchdat};${belegnr};${text};${betrag};${mwst};${steuer};${steucod};${gegenbuchkz};${verbuchkz};${symbol}\r\n`
    }
    return csv;
}